import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get } from 'lodash';
import type {
  ImportAssetFileMutation,
  ImportFileInput,
  ImportFileOutputData,
} from '#/graphql/types';
import { importAssetFile } from '#/graphql/mutations';

const q = gql(importAssetFile);

const useImportAssetFileMutation = () => {
  const [mutation, result] = useMutation<ImportAssetFileMutation>(q);
  const importAssetFile = useCallback(
    async (data: ImportFileInput): Promise<ImportFileOutputData | null> => {
      const response = await mutation({
        variables: {
          data,
        },
      });

      const result = get(response, 'data.importAssetFile', undefined);

      // Check if the operation failed on the backend
      if (result && result.status !== 200) {
        const errorMessage = result.errors?.join('\n') || 'Import failed';
        throw new Error(errorMessage);
      }

      return get(response, 'data.importAssetFile.data', null);
    },
    [mutation],
  );

  return { importAssetFile, result };
};

export default useImportAssetFileMutation;
